

export class FormatDateUtil {
  static formatDateFromAPI(date: string){
    let splitedDate = date.substring(0, 10).split('-')
    let day = splitedDate[2]
    let month = splitedDate[1]
    let year = splitedDate[0]

    const formatedDate = day+'/'+month+'/'+year
    return formatedDate
}

static formatDateString(data: string) {
    return data.replace(/^(\d{4})-(\d{2})-(\d{2})$/, "$3/$2/$1");
}

static convertStringInDate(date: string){
    let splitedDate = date.substring(0, 10).split('-')
    let day = Number.parseInt(splitedDate[2]);
    let month = Number.parseInt(splitedDate[1])
    let year = Number.parseInt(splitedDate[0])

    const formatedDate = new Date(year, month, day)
    return formatedDate
}

static formatDateToString(date: Date, config: any = {}){
    const formatedDate = `${date.getFullYear()}-${date.getMonth() + config.countMonth}-${date.getDate()}`
    return formatedDate
}

static formatDateFromReactiveForm(date: string){
    const [day, month, year] = date.split('/');

    const formatedDate = `${year}-${month}-${day}`
    return formatedDate
}
}
